import { Component, HostBinding, OnDestroy, OnInit, inject } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { ShortcutKeysCatalogService } from 'src/app/shared/services/shortcut-keys-catalog.service';
import {
  ShortcutKeysFooterLinkPageIds,
  ShortcutKeysQueryParam,
} from 'src/app/shared/utility/constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  @HostBinding('class.app-footer--has-link')
  showShortcutKeysLink = false;

  private readonly router = inject(Router);
  private readonly shortcutCatalog = inject(ShortcutKeysCatalogService);
  private readonly destroy$ = new Subject<void>();

  footerShortcutQueryParams: Record<string, string> = {};

  ngOnInit(): void {
    this.updateShortcutQueryParams();
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((e: Event): e is NavigationEnd => e instanceof NavigationEnd)
      )
      .subscribe(() => this.updateShortcutQueryParams());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateShortcutQueryParams(): void {
    const page = this.shortcutCatalog.findPageIdForRouterUrl(this.router.url);
    this.showShortcutKeysLink =
      page !== null && ShortcutKeysFooterLinkPageIds.has(page);
    this.footerShortcutQueryParams =
      this.showShortcutKeysLink && page
        ? { [ShortcutKeysQueryParam.page]: page }
        : {};
  }
}
